@if (loading) {
<div class="flex w-full justify-center items-center" [style.height]="height">
  <nz-spin nzSimple></nz-spin>
</div>
} @else {
<ng-content></ng-content>
}